import './index.css'

const Cloud = () => (
  <div className="cloud-container">
    <img
      src="https://www.stratospherenetworks.com/blog/wp-content/uploads/2020/10/cloud-computing-and-contact-center.jpg"
      alt="cloud"
      className="cl-image"
    />
    <h1 className="cloud-heading">Cloud</h1>
    <h1 className="cl-heading2">
      Move faster, be more agile, and innovate your businesses!
    </h1>
    <p className="cl-para1">
      While most enterprises today have some kind of cloud presence, few
      maximize the vast opportunities that cloud offers. The pressures are
      growing to accelerate company-wide cloud adoption or risk falling behind
      the competition. We help in the cloud adoption journey at all stages.
    </p>
    <p className="cl-para1">
      ‍Strategy:
      <br /> We help identify and assess the key decisions to embark and manage
      deployment of cloud in new and disruptive business models and
      revolutionize the customer experience.
    </p>
    <p className="cl-para1">
      Speed:
      <br /> We enable companies to quickly migrate to the cloud and scale in a
      factory-based model, which ensures efficiency and the flexibility to align
      with business needs.
    </p>
    <div className="main-cloud-container">
      <div className="image-cloud-container">
        <img
          src="https://uploads-ssl.webflow.com/6448bf6f0640203c982ca15f/6448bf6f064020bc502ca468_CLOUD%20MIGRATION%20SERVICES.webp"
          alt="cl"
          className="main-image"
        />
      </div>
      <div className="content-cloud">
        <h1 className="cloud-heading1">Cloud strategy services</h1>
        <p className="p1">* Cloud Readiness assessment.</p>
        <p className="p1">* Cloud roadmap and strategy.</p>
        <p className="p1">* Cloud architecture audit.</p>
        <p className="p1">* Change management..</p>
        <p className="p1">* Cloud security roadmap.</p>
      </div>
    </div>
    <div className="main-cloud-container2">
      <div className="content-cloud2">
        <h1 className="cloud-heading1">Cloud migration services</h1>
        <p className="p1">* Cloud-to-cloud movement.</p>
        <p className="p1">* Migration of workloads.</p>
        <p className="p1">* Validation and performance testing.</p>
        <p className="p1">* Operations run books.</p>
      </div>
      <div className="image-cloud-container">
        <img
          src="https://uploads-ssl.webflow.com/6448bf6f0640203c982ca15f/6448bf6f064020f4d82ca474_CLOUD%20MIGRATION%20SERVICES%20(2).webp"
          alt="cl"
          className="main-image"
        />
      </div>
    </div>
  </div>
)
export default Cloud
